export enum AutopaySteps {
  stepOne = 1,
  stepTwo = 2,
  stepThree = 3,
  confirmAutopayDetails = 4,
}
